import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-[#030712] text-slate-900 dark:text-slate-200 font-body py-16 px-4 sm:px-6 transition-colors duration-300">
      <div className="max-w-4xl mx-auto space-y-8 glass-panel p-8 md:p-12 rounded-3xl">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-bold text-blue-600 dark:text-cyan-400 hover:underline font-heading">
          <ArrowLeft size={14} /> Back to Home
        </Link>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-blue-600 dark:text-cyan-400 font-heading">Legal & Compliance</span>
          <h1 className="font-heading text-3xl font-extrabold text-slate-900 dark:text-white">Privacy Policy</h1>
          <p className="text-xs text-slate-500 dark:text-slate-400">Last updated: August 2026</p>
        </div>

        <div className="space-y-6 text-sm text-slate-700 dark:text-slate-300 leading-relaxed font-medium">
          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">1. Information Collection</h3>
            <p>
              Hickter Technology Solutions collects information provided directly by clients when requesting IT proposals, submitting project inquiries, or booking technical discovery calls. This includes contact details, business requirements, and project scope data.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">2. Use of Information</h3>
            <p>
              Collected data is used strictly for evaluating project milestones, delivering contract services, and maintaining 24/7 SLA technical support.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">3. Data Protection & Security</h3>
            <p>
              We implement industry-standard encryption, modern security guidelines, and strict access controls to prevent unauthorized access, disclosure, or modification of client databases and source code.
            </p>
          </section>

          <section className="space-y-2">
            <h3 className="font-heading text-lg font-bold text-slate-900 dark:text-white">4. Contact Us</h3>
            <p>
              If you have questions regarding this Privacy Policy, please reach out to us at <a href="mailto:contact@hickter.com" className="text-blue-600 dark:text-cyan-400 font-bold hover:underline">contact@hickter.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
